const REQUEST_FUNDING_FAQS = 'platfi-ui-app/FUNDING/REQUEST_FUNDING_FAQS';
const REQUEST_FUNDING_FAQS_SUCCESS = 'platfi-ui-app/FUNDING/REQUEST_FUNDING_FAQS_SUCCESS';
const REQUEST_FUNDING_FAQS_FAILURE = 'platfi-ui-app/FUNDING/REQUEST_FUNDING_FAQS_FAILURE';

export { REQUEST_FUNDING_FAQS, REQUEST_FUNDING_FAQS_SUCCESS, REQUEST_FUNDING_FAQS_FAILURE };
